export class Table {
    uuid: string;
    nombre_es: string;
    nombre_en:string;
}